import StopIcon from "@mui/icons-material/Stop";
import { Chip } from "@mui/material";
import React from "react";
function TagChip({ tag, style }) {
    const { color } = tag;
    const _color = color === "#000000" ? "rgba(0,0,0,0.3)" : color;
    const Icon = <StopIcon style={{ color: _color, fontSize: 14 }} />;
    const _style = Object.assign(
        {},
        {
            marginRight: 5,
            marginBottom: 3,
        },
        style
    );
    return <Chip icon={Icon} style={_style} variant="outlined" label={tag.value} />;
}

export default TagChip;
